import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative h-auto" }
const _hoisted_2 = {
  key: 0,
  position: "stacked",
  class: "text-lg block"
}
const _hoisted_3 = {
  key: 1,
  position: "stacked",
  class: "mb-3"
}
const _hoisted_4 = {
  key: 2,
  id: "validation_error",
  class: "absolute -bottom-6 kl-red"
}

import { IonItem } from '@ionic/vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'InputWrapper',
  props: {
    label: {
        type: String,
        default: '',
    },
    header3: {
        type: String,
        default: '',
    },
    currency: {
        type: Boolean,
        default: false,
    },
    error: {
        type: Object,
        default: () => ({}),
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("h6", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    (__props.header3)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(__props.header3), 1))
      : _createCommentVNode("", true),
    _createVNode(_unref(IonItem), {
      lines: "none",
      class: _normalizeClass(["w-full mt-2 mb-5", { 'currency-input': __props.currency }])
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]),
    (Object.keys(__props.error).length)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.error[0]), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})